export var CustomerChatSenderType;
(function (CustomerChatSenderType) {
    CustomerChatSenderType["CUSTOMER"] = "CUSTOMER";
    CustomerChatSenderType["MANAGER"] = "MANAGER";
    CustomerChatSenderType["AI_AGENT"] = "AI_AGENT";
})(CustomerChatSenderType || (CustomerChatSenderType = {}));
